//@ts-nocheck
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * @flow
 */
// 'use strict';

import * as React from 'react';
import {
  Keyboard,
  LayoutAnimation,
  Platform,
  StyleSheet,
  View,
  Dimensions,
} from 'react-native';
import {getBottomSpace} from 'react-native-iphone-x-helper';
type Props = JSX.LibraryManagedAttributes<
  typeof View,
  React.ComponentProps<typeof View>
> & {
  insideTab?: boolean;
  children: React.ReactNode;
  behavior?: string;
};
type State = {
  keyboardHeight: number;
};
const TAB_BAR_HEIGHT = 49;
/**
 * View that moves out of the way when the keyboard appears by automatically
 * adjusting its height, position, or bottom padding.
 */

class KeyboardAvoidingView extends React.Component<Props, State> {
  _subscriptions: Array<any> = [];
  static defaultProps = {
    insideTab: false,
  };

  constructor(props: Props) {
    super(props);
    this.state = {
      keyboardHeight: 0,
    };
  }

  _onKeyboardChange = (event: Keyboard.KeyboardEvent | null | undefined) => {
    if (event == null) {
      this.setState({
        keyboardHeight: 0,
      });
      return;
    }

    const window = Dimensions.get('window');
    const {duration, easing, endCoordinates} = event;
    let keyboardHeight =
      window.height - endCoordinates.screenY - getBottomSpace();

    if (this.props.insideTab) {
      keyboardHeight -= TAB_BAR_HEIGHT;
    }

    const height = Math.max(keyboardHeight, 0);

    if (this.state.keyboardHeight === height) {
      return;
    }

    if (duration && easing) {
      LayoutAnimation.configureNext({
        // We have to pass the duration equal to minimal accepted duration defined here: RCTLayoutAnimation.m
        duration: duration > 10 ? duration : 10,
        update: {
          duration: duration > 10 ? duration : 10,
          type: LayoutAnimation.Types[easing] || 'keyboard',
        },
      });
    }

    this.setState({
      keyboardHeight: height,
    });
  };

  componentDidMount(): void {
    if (Platform.OS === 'ios') {
      this._subscriptions = [
        Keyboard.addListener('keyboardWillChangeFrame', this._onKeyboardChange),
      ];
    }
  }

  componentWillUnmount(): void {
    this._subscriptions.forEach((subscription) => {
      subscription.remove();
    });
  }

  render(): React.ReactNode {
    return (
      <View style={styles.container}>
        <View style={styles.container} {...this.props}>
          {this.props.children}
        </View>
        <View
          style={{
            height: this.state.keyboardHeight,
          }}
        />
      </View>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
});
export default KeyboardAvoidingView;
